"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ATOZ_FEATURE_PATH = void 0;
exports.ATOZ_FEATURE_PATH = {
    TIME_OFF: '/time',
    ATTENDANCE: '/time/attendance',
    ABSENCE: '/time/absence/request',
    PAY: '/pay',
    TIME_CARD: '/timecard',
    TASK_LIST: '/timecard/tasklist',
    CORRECT_PUNCHES: '/timecard/correct-punches',
    REPORT_TRAVEL_TIME: '/timecard/report-travel-time'
};
